import { Route } from "react-router";

import { queryClient } from "@/providers/QueryClient";
import { loadSearchTablePreferences } from "@/shared/domain/config/loaders/loadSearchTablePreferences";
import { QueryTarget } from "@/shared/domain/query";
import { makeViewsLoader } from "@/shared/domain/views/loaders/loadViews";
import { composeLoaders } from "@/shared/routing/composeLoaders";

import { EventsPage } from "./EventsPage";

// See `DatasetsRoutes`: preferences, plus the `?view=` View when there is one.
const eventsListLoader = composeLoaders(
  loadSearchTablePreferences(queryClient, "event_search_table_preferences"),
  makeViewsLoader(queryClient, { target: QueryTarget.Events }),
);

export const EventsRoutes = () => [
  <Route key={"/"} index loader={eventsListLoader} element={<EventsPage />} />,
];
